<template>
	<div class="section-heading flow">
		<slot/>
		<hr/>
	</div>
</template>
